import React from 'react';
import BreadcrumbItem from "../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../component/Page/Page";
import MovementOrderForm from "./MovementOrderForm";

class MovementOrderFormPage extends React.Component {

  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Cadastros"/>,
      <BreadcrumbItem key={2} title="Lista de Ordem de Movimentações"
                      to="/list/movement-orders"/>,
      <BreadcrumbItem key={3} title="Nova Ordem de Movimentação"
                      active={true}/>];
    return (
        <Page title="Dados do BizTransaction" breadcrumbs={breadcrumbs}>
          <MovementOrderForm match={match} history={history}/>
        </Page>
    );
  }
}

export default MovementOrderFormPage;


// WEBPACK FOOTER //
// ./src/movementOrder/MovementOrderFormPage.js